package example.shadcn_kotlin.ui.pages.docs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*
import example.shadcn_kotlin.ui.components.*
import example.shadcn_kotlin.ui.docs.index.*

@Page
@Composable
fun IndexPage() {
    CompositionLocalProvider(LocalMarkdownContext provides MarkdownContext("docs/index.md", mapOf("title" to listOf("Introduction"), "description" to listOf("Re-usable components built using Radix UI and Tailwind CSS.")))) {
        example.shadcn_kotlin.ui.components.layouts.MDLayout {
            org.jetbrains.compose.web.dom.P({ classes("leading-7","[&:not(:first-child)]:mt-6") }) {
                org.jetbrains.compose.web.dom.Text("An unofficial, ")
                org.jetbrains.compose.web.dom.A("https://kotlinlang.org/", { classes("font-medium","underline","underline-offset-4") }) {
                    org.jetbrains.compose.web.dom.Text("Kotlin")
                }
                org.jetbrains.compose.web.dom.Text(" port of ")
                org.jetbrains.compose.web.dom.A("https://ui.shadcn.com", { classes("font-medium","underline","underline-offset-4") }) {
                    org.jetbrains.compose.web.dom.Text("shadcn/ui")
                }
                org.jetbrains.compose.web.dom.Text(". This is not affiliated with ")
                org.jetbrains.compose.web.dom.A("https://twitter.com/shadcn", { classes("font-medium","underline","underline-offset-4") }) {
                    org.jetbrains.compose.web.dom.Text("shadcn")
                }
                org.jetbrains.compose.web.dom.Text(" but inspired by him. This is a project born out of the need for a similar project for the KotlinJs ecosystem.")
            }
            com.varabyte.kobweb.compose.dom.GenericTag("br")
            Callout()
            org.jetbrains.compose.web.dom.P({ classes("leading-7","[&:not(:first-child)]:mt-6") }) {
                org.jetbrains.compose.web.dom.Text("This is a component library. It's a collection of re-usable components that you can add to your apps.")
            }
            org.jetbrains.compose.web.dom.P({ classes("leading-7","[&:not(:first-child)]:mt-6") }) {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("What do you mean a component library? Is it different from original project?")
                }
            }
            org.jetbrains.compose.web.dom.P({ classes("leading-7","[&:not(:first-child)]:mt-6") }) {
                org.jetbrains.compose.web.dom.Text("It means you have to install it as a dependency. It is published on maven-central. You get all the components you need in a single library.")
            }
            org.jetbrains.compose.web.dom.P({ classes("leading-7","[&:not(:first-child)]:mt-6") }) {
                org.jetbrains.compose.web.dom.Em {
                    org.jetbrains.compose.web.dom.Text("Use this as a reference to build your own component libraries.")
                }
            }
            org.jetbrains.compose.web.dom.H2({ 
classes("font-heading","mt-12","scroll-m-20","border-b","pb-2","text-2xl","font-semibold","tracking-tight","first:mt-0")
id("faq")
 }) {
                org.jetbrains.compose.web.dom.Text("FAQ")
            }
            Faq()
            org.jetbrains.compose.web.dom.H2({ 
classes("font-heading","mt-12","scroll-m-20","border-b","pb-2","text-2xl","font-semibold","tracking-tight","first:mt-0")
id("credits")
 }) {
                org.jetbrains.compose.web.dom.Text("Credits")
            }
            org.jetbrains.compose.web.dom.Ul({ classes("my-6","ml-6","list-disc") }) {
                org.jetbrains.compose.web.dom.Li({ classes("mt-2") }) {
                    org.jetbrains.compose.web.dom.A("https://twitter.com/shadcn", { classes("font-medium","underline","underline-offset-4") }) {
                        org.jetbrains.compose.web.dom.Text("@shadcn")
                    }
                    org.jetbrains.compose.web.dom.Text(" - The brilliant mind behind the designs, methodology, and implementation.")
                }
                org.jetbrains.compose.web.dom.Li({ classes("mt-2") }) {
                    org.jetbrains.compose.web.dom.A("https://vercel.com", { classes("font-medium","underline","underline-offset-4") }) {
                        org.jetbrains.compose.web.dom.Text("Vercel")
                    }
                    org.jetbrains.compose.web.dom.Text(" - Where this project is hosted.")
                }
                org.jetbrains.compose.web.dom.Li({ classes("mt-2") }) {
                    org.jetbrains.compose.web.dom.A("https://shud.in", { classes("font-medium","underline","underline-offset-4") }) {
                        org.jetbrains.compose.web.dom.Text("Shu Ding")
                    }
                    org.jetbrains.compose.web.dom.Text(" - The typography style is adapted from his work on Nextra.")
                }
                org.jetbrains.compose.web.dom.Li({ classes("mt-2") }) {
                    org.jetbrains.compose.web.dom.A("https://cal.com", { classes("font-medium","underline","underline-offset-4") }) {
                        org.jetbrains.compose.web.dom.Text("Cal")
                    }
                    org.jetbrains.compose.web.dom.Text(" - Where shad copied the styles for the first component: the ")
                    org.jetbrains.compose.web.dom.Code({ classes("bg-muted","py-[0.2rem]","px-[0.3rem]","rounded","text-sm") }) {
                        org.jetbrains.compose.web.dom.Text("Button")
                    }
                    org.jetbrains.compose.web.dom.Text(".")
                }
                org.jetbrains.compose.web.dom.Li({ classes("mt-2") }) {
                    org.jetbrains.compose.web.dom.A("https://github.com/varabyte/kobweb", { classes("font-medium","underline","underline-offset-4") }) {
                        org.jetbrains.compose.web.dom.Text("@verabyte")
                    }
                    org.jetbrains.compose.web.dom.Text(" - The KotlinJs framework: ")
                    org.jetbrains.compose.web.dom.A("https://github.com/varabyte/kobweb", { classes("font-medium","underline","underline-offset-4") }) {
                        org.jetbrains.compose.web.dom.Text("Kobweb")
                    }
                    org.jetbrains.compose.web.dom.Text(" which made building this site a lot easier")
                }
                org.jetbrains.compose.web.dom.Li({ classes("mt-2") }) {
                    org.jetbrains.compose.web.dom.A("https://gitlab.com/clovis-ai", { classes("font-medium","underline","underline-offset-4") }) {
                        org.jetbrains.compose.web.dom.Text("@clovis-ai")
                    }
                    org.jetbrains.compose.web.dom.Text(" - Where I got the updated Gradle Configurations for Tailwind CSS")
                }
                org.jetbrains.compose.web.dom.Li({ classes("mt-2") }) {
                    org.jetbrains.compose.web.dom.A("https://github.com/lukeshay", { classes("font-medium","underline","underline-offset-4") }) {
                        org.jetbrains.compose.web.dom.Text("@lukeshay")
                    }
                    org.jetbrains.compose.web.dom.Text(" - Which provides the ")
                    org.jetbrains.compose.web.dom.A("https://github.com/lukeshay/ui", { classes("font-medium","underline","underline-offset-4") }) {
                        org.jetbrains.compose.web.dom.Text("published version")
                    }
                    org.jetbrains.compose.web.dom.Text(" of shadcn library")
                }
            }
        }
    }
}
